<script setup>
import InputVue from './InputCompVue'

import { ref, useTemplateRef } from 'vue'

const { modelValue } = defineProps({
  name: String,
  label: String,
  cssClasses: String,
  labelAsPlaceholder: Boolean,
  placeholder: String,
  modelValue: String,
  alignment: {
    type: String,
    default: 'horizontal',
  },
})
const emit = defineEmits([
  'update:modelValue',
])
const hasError = ref(false)
const inputEl = useTemplateRef('inputEl')
const val = ref(modelValue)

const onChangeInput = (e) => {
  val.value = e.target.value
  emit('update:modelValue', val.value)
}

const onChangeColor = (e) => {
  val.value = e.target.value
  emit('update:modelValue', val.value)
}

const reset = () => {
}

const getValue = () => {
  return val.value
}

const focusInput = () => {
  inputEl.value.focus()
}

defineExpose({ reset, getValue })

</script>

<template>
  <InputVue
    :name="name"
    :label="label"
    :tabindex="0"
    class="color-input-cont"
    :cssClasses="cssClasses"
    :labelAsPlaceholder="labelAsPlaceholder"
    :hasError="hasError"
    :alignment="alignment"
    @input="onChangeInput">
    <template #input-slot>
      <div class="color-input-wrapper flex align-center">
        <input 
          ref="inputEl"
          class="form-control color-input" 
          autocomplete="off"
          :value="modelValue"
          :name="name" 
          type="color"
          @change="onChangeColor"
          :placeholder="labelAsPlaceholder ? label : placeholder " />
        <input
          class="form-control text-input"
          type="text"
          :value="modelValue"
          @input="onChangeValue"
          @click.enter="onChangeInput" />
      </div>
    </template>
  </InputVue>
</template>

<style lang="scss" scoped>
.color-input-cont {
  .color-input-wrapper {
    .form-control {
      &.color-input {
        width: 50px;
        border-right: none;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;

        &:focus + .text-input,
        &:focus-visible + .text-input {
          border-color: color(primary);
        }

        &:has( + .text-input:focus),
        &:has( + .text-input:focus-visible) {
          border-color: color(primary);
        }
      }
      
      &.text-input {
        border-left: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
}
</style>
